import { Navigate, Outlet } from "react-router-dom";

const PublicRoutes = () => {
  const isAuthenticated = localStorage.getItem("authToken");
  return isAuthenticated ? <Navigate to="/user" /> : <Outlet />;
};

export default PublicRoutes;
